// Mirrors backend normalizeKey (see bu-admin-frontend PermissionRole service) so
// route/permission keys used here compare equal to the normalized keys stored in
// the DB, while still matching old raw literal keys (e.g. "salesFeed").
export const normalizeKey = (raw) => {
  if (!raw || typeof raw !== "string") return raw;
  return raw
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_]/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");
};

// Looks a privilege value up by key regardless of whether the stored key is an
// old raw literal or a backend-normalized one — both resolve to the same
// normalized form.
export const getPrivilege = (privileges, key) => {
  if (!privileges) return undefined;
  const target = normalizeKey(key);
  const found = Object.keys(privileges).find((k) => normalizeKey(k) === target);
  return found !== undefined ? privileges[found] : undefined;
};

export const isAllowed = (privileges, key) => {
  const value = getPrivilege(privileges, key);
  return !!value && value !== "Not allowed";
};

const buildPrivilegesFromGroupPermissions = (groupPermissions) => {
  if (!Array.isArray(groupPermissions) || groupPermissions.length === 0) return null;
  const privileges = {};
  groupPermissions.forEach((perm) => {
    if (!perm?.key) return;
    privileges[perm.key] = (perm.level || "").toString().replace(/_/g, " ");
  });
  return Object.keys(privileges).length > 0 ? privileges : null;
};

export const getEffectivePrivileges = (userData) => {
  try {
    const raw = localStorage.getItem("groupPermissions");
    if (raw !== null && raw !== "undefined" && raw !== "null" && raw !== "") {
      const parsed = JSON.parse(raw);
      const built = buildPrivilegesFromGroupPermissions(parsed);
      if (built) return built;
    }
  } catch {
    // fall through to userData-based privileges
  }
  return userData?.Group?.privileges || userData?.privileges || {};
};
